const taskSheetStorage = require('./task-sheet-storage');

function parseSheetId(raw) {
    if (raw === 'all' || raw === '' || raw === null || raw === undefined) {
        return 'all';
    }

    const id = parseInt(raw, 10);

    return id > 0 ? String(id) : 'all';
}

function rowMatchesSheet($row, sheetId) {
    if (sheetId === 'all') {
        return true;
    }

    const rowSheet = String($row.attr('data-task-sheet-id') || '');

    return rowSheet === String(sheetId);
}

function applyTaskSheetFilter($wrapper, sheetId) {
    if (!$wrapper || !$wrapper.length) {
        return;
    }

    const activeSheet = parseSheetId(sheetId);

    $wrapper.find('.subprojects-grid tbody tr').each(function () {
        const $row = $(this);
        $row.toggle(rowMatchesSheet($row, activeSheet));
    });

    $wrapper.find('.kanban-card').each(function () {
        const $card = $(this);
        $card.toggle(rowMatchesSheet($card, activeSheet));
    });

    $wrapper.find('.kanban-group').each(function () {
        const $group = $(this);
        const visibleCards = $group.find('.kanban-card:visible').length;
        $group.toggle(visibleCards > 0 || activeSheet === 'all');
    });

    $wrapper.find('.kanban-column').each(function () {
        const $col = $(this);
        const visibleCards = $col.find('.kanban-card:visible').length;
        $col.find('.kanban-empty-column').toggle(visibleCards === 0);
    });
}

function setActiveTab($tabs, sheetId) {
    const activeSheet = parseSheetId(sheetId);

    $tabs.find('li').removeClass('active');
    $tabs.find('a[data-sheet-id]').each(function () {
        const $link = $(this);
        if (String($link.data('sheet-id')) === activeSheet) {
            $link.closest('li').addClass('active');
        }
    });
}

function getActiveSheetFromTabs($tabs) {
    const $active = $tabs.find('li.active a[data-sheet-id]').first();

    if ($active.length) {
        return parseSheetId($active.data('sheet-id'));
    }

    return 'all';
}

function initTaskSheetsForWrapper($wrapper, config) {
    if (!config || !config.showTabs) {
        return null;
    }

    const $tabs = $wrapper.find('.task-sheets-tabs').first();
    if (!$tabs.length) {
        return null;
    }

    const projectId = config.projectId;
    const userId = config.userId;
    const validSheetIds = config.sheetIds || [];

    const saved = taskSheetStorage.getLastTaskSheet(projectId, userId, validSheetIds);
    setActiveTab($tabs, saved);
    applyTaskSheetFilter($wrapper, saved);

    return {
        getActiveSheetId() {
            return getActiveSheetFromTabs($tabs);
        },
        apply(sheetId) {
            setActiveTab($tabs, sheetId);
            applyTaskSheetFilter($wrapper, sheetId);
            taskSheetStorage.setLastTaskSheet(projectId, userId, sheetId);
        },
    };
}

function initTaskSheetsDocumentHandlers(config) {
    if (!config || !config.showTabs) {
        return;
    }

    function rememberCreatedSheet(sheet) {
        if (!config.sheetIds) {
            config.sheetIds = [];
        }

        if (!config.sheetIds.includes(sheet.id)) {
            config.sheetIds.push(sheet.id);
        }

        taskSheetStorage.setLastTaskSheet(config.projectId, config.userId, sheet.id);
    }

    $(document).off('click.taskSheets', '.task-sheets-tabs a[data-sheet-id]').on('click.taskSheets', '.task-sheets-tabs a[data-sheet-id]', function (e) {
        e.preventDefault();
        const $link = $(this);
        const $tabs = $link.closest('.task-sheets-tabs');
        const $wrapper = $tabs.closest('.task-grid-inner-wrapper');
        const sheetId = parseSheetId($link.data('sheet-id'));
        const projectId = config.projectId;
        const userId = config.userId;

        setActiveTab($tabs, sheetId);
        applyTaskSheetFilter($wrapper, sheetId);
        taskSheetStorage.setLastTaskSheet(projectId, userId, sheetId);

        if (typeof window.reloadGanttForActiveTaskSheet === 'function') {
            window.reloadGanttForActiveTaskSheet($wrapper);
        }
    });

    $(document).off('click.taskSheets', '.task-sheet-add-btn').on('click.taskSheets', '.task-sheet-add-btn', function (e) {
        e.preventDefault();
        if (!config.canModify || !config.routes || !config.routes.store) {
            return;
        }

        Swal.fire({
            title: 'Nuovo Working Block',
            input: 'text',
            inputPlaceholder: 'Nome Working Block',
            showCancelButton: true,
            confirmButtonText: 'Crea',
            cancelButtonText: 'Annulla',
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return 'Inserisci un nome';
                }

                return null;
            },
        }).then((result) => {
            if (!result.isConfirmed || !result.value) {
                return;
            }

            $.ajax({
                url: config.routes.store,
                method: 'POST',
                data: {
                    name: result.value.trim(),
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success(response) {
                    if (!response.success || !response.sheet) {
                        return;
                    }

                    const sheet = response.sheet;
                    rememberCreatedSheet(sheet);
                    window.location.reload();
                },
                error(xhr) {
                    const msg = xhr.responseJSON?.message
                        || (xhr.responseJSON?.errors?.name ? xhr.responseJSON.errors.name[0] : null)
                        || 'Errore durante la creazione del Working Block';
                    Swal.fire({ icon: 'error', title: 'Errore', text: msg });
                },
            });
        });
    });
}

function appendSheetTab(sheet, $tabs) {
    const $addLi = $tabs.find('.task-sheets-tab-add').first();
    if (!$addLi.length) {
        return;
    }

    const $newLi = $('<li></li>');
    $newLi.append(
        $('<a href="#"></a>').attr('data-sheet-id', sheet.id).text(sheet.name)
    );
    $addLi.before($newLi);
}

function getActiveTaskSheetIdForStore($wrapper) {
    const $tabs = $wrapper.find('.task-sheets-tabs').first();
    if (!$tabs.length) {
        return null;
    }

    const active = getActiveSheetFromTabs($tabs);

    return active === 'all' ? null : parseInt(active, 10);
}

function setLastTaskSheet(projectId, userId, sheetIdOrAll) {
    taskSheetStorage.setLastTaskSheet(projectId, userId, sheetIdOrAll);
}

module.exports = {
    initTaskSheetsForWrapper,
    initTaskSheetsDocumentHandlers,
    applyTaskSheetFilter,
    getActiveTaskSheetIdForStore,
    appendSheetTab,
    parseSheetId,
    setLastTaskSheet,
};
